module.exports = {
  envName: 'cromaprod',
  dashboardUrl: 'https://dashboard.casa.croma.com',
  ruleServerUrl: 'https://api.casa.croma.com',
  turnedOffFeatures: ['journey-builder', 'flipbook-image-tagger']
};
